// extracted by mini-css-extract-plugin
module.exports = {"locl-infinite-marquee":"infinite-marquee_locl-infinite-marquee__Whcbv","locl-infinite-marquee__item":"infinite-marquee_locl-infinite-marquee__item__WnqQx"};